import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import JobsList from './pages/JobsList';
import JobEditor from './pages/JobEditor';
import EventTriggers from './pages/EventTriggers';
import ExecutionHistory from './pages/ExecutionHistory';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="jobs" element={<JobsList />} />
          <Route path="jobs/new" element={<JobEditor />} />
          <Route path="jobs/:id/edit" element={<JobEditor />} />
          <Route path="triggers" element={<EventTriggers />} />
          <Route path="history" element={<ExecutionHistory />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
